import { httpClient } from '@/services/http/httpClient'

import type { IdeaFeedParameters } from '../types'

type Params = {
  [key in IdeaFeedParameters]: boolean
}

export async function updateIdeaFeedParams({
  activeChallengesIdeas,
  allIdeas,
  allUsersIdeas,
  ownIdeas,
  rejectedIdeas,
  reviewedIdeas,
  unReviewedIdeas,
}: Params): Promise<void> {
  const payload = {
    all_ideas: allIdeas,
    own_ideas: ownIdeas,
    all_users_ideas: allUsersIdeas,
    unreviewed_ideas: unReviewedIdeas,
    reviewed_ideas: reviewedIdeas,
    rejected_ideas: rejectedIdeas,
    active_challenges_ideas: activeChallengesIdeas,
  }

  await httpClient.put('/tennants/configs/idea-feed', payload)
}
